


  import dep0 from "ember-route-state/-embroider-implicit-modules.js";

  import * as own0 from "ember-source/ember/index.js";

export default Object.assign({},
    dep0,
  {
      "ember/index": own0,
  }
);
